// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomTooltip_tooltip__MeCsV {
  background-color: #FFFFFF;
  border-radius: 4px;
  opacity: 1;
  position: absolute;
  transform: translate(calc(-100% - 10px), 5px);
  transition: all 0.1s ease;
  padding: 10px;
  pointer-events: none;
  box-shadow: 0px 4px 12px 0px #E0E0E3;
}
.CustomTooltip_tooltip__MeCsV .CustomTooltip_title__xqxWS {
  font-weight: 500;
  font-size: 14px;
}
.CustomTooltip_tooltip__MeCsV ul {
  padding: 0;
  margin: 0;
}
.CustomTooltip_tooltip__MeCsV ul li {
  width: max-content;
  list-style-type: none;
  padding-top: 5px;
}
.CustomTooltip_tooltip__MeCsV ul li .CustomTooltip_color__IjwvQ {
  width: 12px;
  height: 12px;
  margin-right: 8px;
  border-radius: 2px;
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}
.CustomTooltip_tooltip__MeCsV.CustomTooltip_hidden__DFJTw {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/reporting/components/graphs/CustomTooltip/CustomTooltip.module.scss","webpack://./src/components/reporting/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,yBCHM;EDIN,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,6CAAA;EACA,yBAAA;EACA,aAAA;EACA,oBAAA;EACA,oCAAA;AAkBF;AAhBE;EACE,gBAAA;EACA,eAAA;AAkBJ;AAfE;EACE,UAAA;EACA,SAAA;AAiBJ;AAfI;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;AAiBN;AAfM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;AAiBR;AAZE;EACE,UAAA;AAcJ","sourcesContent":["@use 'components/reporting/styles/colors.scss';\n\n\n.tooltip{\n  background-color: colors.$light;\n  border-radius: 4px;\n  opacity: 1;\n  position: absolute;\n  transform: translate(calc(-100% - 10px), 5px);\n  transition: all .1s ease;\n  padding: 10px;\n  pointer-events: none;\n  box-shadow: 0px 4px 12px 0px colors.$grey4;\n\n  .title{\n    font-weight: 500;\n    font-size: 14px;\n  }\n\n  ul{\n    padding: 0;\n    margin: 0;\n\n    li{\n      width: max-content;\n      list-style-type: none;\n      padding-top: 5px;\n\n      .color{\n        width: 12px;\n        height: 12px;\n        margin-right: 8px;\n        border-radius: 2px;\n        display: inline-block;\n        vertical-align: middle;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  &.hidden{\n    opacity: 0;\n  }\n}\n\n\n\n","$dark: #121217;\n$light: #FFFFFF;\n\n$grey1: #3E3E50;\n$grey2: #838390;\n$grey3: #C3C3C9;\n$grey4: #E0E0E3;\n$grey5: #F9F9FA;\n\n$blue1: #00007A;\n$blue2: #0000C9;\n$blue3: #4343FF;\n$blue4: #8686FF;\n$blue5: #D8D8FF;\n$blueLogo: #000093;\n\n$orange1: #DA8200;\n$orange2: #FFA92C;\n$orange3: #FFC26B;\n$orange4: #FFE1B7;\n$orange5: #FFF3E3;\n\n$green1: #033E0F;\n$green2: #218214;\n$green3: #58B441;\n$green4: #89D96B;\n$green5: #E1F8CE;\n\n$brick1: #7D1F01;\n$brick2: #B94402;\n$brick3: #E78D3D;\n$brick4: #FBD298;\n$brick5: #FDEBCB;\n\n$red1: #540726;\n$red2: #7C1028;\n$red3: #BD454A;\n$red4: #F4ADA1;\n$red5: #F9D9CF;\n\n\n:export {\n    light: $light;\n    dark: $dark;\n    blue1: $blue1;\n    blue2: $blue2;\n    blue3: $blue3;\n    blue4: $blue4;\n    blue5: $blue5;\n    orange1: $orange1;\n    orange2: $orange2;\n    orange3: $orange3;\n    orange4: $orange4;\n    orange5: $orange5;\n    grey1: $grey1;\n    grey2: $grey2;\n    grey3: $grey3;\n    grey4: $grey4;\n    grey5: $grey5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `#FFFFFF`,
	"dark": `#121217`,
	"blue1": `#00007A`,
	"blue2": `#0000C9`,
	"blue3": `#4343FF`,
	"blue4": `#8686FF`,
	"blue5": `#D8D8FF`,
	"orange1": `#DA8200`,
	"orange2": `#FFA92C`,
	"orange3": `#FFC26B`,
	"orange4": `#FFE1B7`,
	"orange5": `#FFF3E3`,
	"grey1": `#3E3E50`,
	"grey2": `#838390`,
	"grey3": `#C3C3C9`,
	"grey4": `#E0E0E3`,
	"grey5": `#F9F9FA`,
	"tooltip": `CustomTooltip_tooltip__MeCsV`,
	"title": `CustomTooltip_title__xqxWS`,
	"color": `CustomTooltip_color__IjwvQ`,
	"hidden": `CustomTooltip_hidden__DFJTw`
};
export default ___CSS_LOADER_EXPORT___;
